import Application from "../../Application";
import { IAuthenticationService } from "../../service/authentication/AuthenticationService";
import { IUserService } from "../../service/user/UserService";

export default class ChangePasswordInteractor {
  private application: Application;
  private authenticationService: IAuthenticationService;
  private userService: IUserService;

  constructor(application, authenticationService, userService) {
    this.application = application;
    this.authenticationService = authenticationService;
    this.userService = userService;
  }

  async execute(
    newPassword: string,
    oldPassword: string,
    username?: string,
    token?: string
  ) {
    let userProfile;
    if (!username && !token) {
      userProfile = await this.userService.getUserProfile();
    }
    return this.authenticationService.changePassword(
      newPassword,
      oldPassword,
      username || userProfile?.username,
      token || undefined
    );
  }
}
